// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1LjLJpA1-ulVdPlidcZoe- {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n}\n.RFDYFDpHdMLn56ZJMu_KL {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n}\n._3togMkgqQscUC7QokBYG4X {\n  flex: 0 0 75px;\n  z-index: 10;\n}\n\n._30U72yI-NW49v7EUt_J7W6 {\n  overflow: hidden !important;\n}\n._1pZcwTOCJWwLh_GxgwEyJT {\n  width: 100%;\n  overflow: hidden !important;\n}\n.wy95DJckB3YX17nfHcCuA {\n  width: 100%;\n}\n\n._2O5SNPHi9dtkQk83Vy6orH {\n}\n.FIguGxLWqR8W0kdihk8qp {\n  background-color: rgba(0, 0, 0, .1);\n}\n\n._1g7T7rn-_L7JTtM34slHwh,\n._3uvS7LoIlGJgjjHlxWCI68,\n.US6X-n7IpIwMKxHOR7-6v {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 0 .5em;\n}\n._3uvS7LoIlGJgjjHlxWCI68,\n.US6X-n7IpIwMKxHOR7-6v {\n  font-weight: bold;\n}\n", ""]);
// Exports
exports.locals = {
	"GridRow": "_1LjLJpA1-ulVdPlidcZoe-",
	"GridColumn": "RFDYFDpHdMLn56ZJMu_KL",
	"LeftSideGridContainer": "_3togMkgqQscUC7QokBYG4X",
	"LeftSideGrid": "_30U72yI-NW49v7EUt_J7W6",
	"HeaderGrid": "_1pZcwTOCJWwLh_GxgwEyJT",
	"BodyGrid": "wy95DJckB3YX17nfHcCuA",
	"evenRow": "_2O5SNPHi9dtkQk83Vy6orH",
	"oddRow": "FIguGxLWqR8W0kdihk8qp",
	"cell": "_1g7T7rn-_L7JTtM34slHwh",
	"headerCell": "_3uvS7LoIlGJgjjHlxWCI68",
	"leftCell": "US6X-n7IpIwMKxHOR7-6v"
};
module.exports = exports;
